// extracted by mini-css-extract-plugin
module.exports = {"root":"AppShell-desktop-module__root___-GALm","content":"AppShell-desktop-module__content___rttDd"};